/**
 * Is this "name" actually a name, or the absence of one?
 *
 * The app's profile ships with "Select name" untouched, older builds wrote
 * "Enter name" / "Untitled" / "None", and a fallback somewhere puts the
 * email address in the name slot. Every one of those is a person who has
 * never told us what to call them, and every surface that shows a name has
 * been re-deriving that test slightly differently. This is the one rule —
 * and it is EXACTLY the one the worker's /account/identity applies on its
 * side: empty, the four defaults, or anything containing "@". Keep the two
 * lists identical, so the site and the server agree about who still needs
 * to be asked.
 */
const PLACEHOLDERS = ["", "select name", "enter name", "untitled", "none"];

export const isPlaceholderName = (name?: string | null): boolean => {
    const v = (name || "").trim().toLowerCase();
    // An email address is a stand-in the server fell back to, never a name.
    if (v.includes("@")) return true;
    return PLACEHOLDERS.includes(v);
};
